<template>
  <div v-if="alert.hasAny" class="mt-5">  <!--style="width: 100%; display: contents; white-space: nowrap; "-->
    <section v-if="alert.hasInfo" class="alert alert-info"><span v-html="alert.info"></span></section>
    <section v-if="alert.hasSuccess" class="alert alert-success"><span v-html="alert.success"></span></section>
    <section v-if="alert.hasWarning" class="alert alert-warning"><span v-html="alert.warning"></span></section>
    <section v-if="alert.hasError" class="alert alert-danger"><p v-html="alert.error"></p></section>
  </div>
</template>
<script>
  // WrsAlert.vue

  export default {
    props: ['alert'],
  }
</script>

